module.exports = __webpack_public_path__ + "static/media/clients.c96487be.svg";